<template lang="pug">
  .wrap
    StartingBusinessListSidebar(:openSidebar="openSidebar" @toggleSidebar="toggleSidebar")

    .main
      .job-list
        .job-list-header(:class="{ 'job-list-header-fixed-sp': false }")
          StartingBusinessListSortArea(
            @searchOrderBy="searchOrderBy"
            @toggleSidebar="toggleSidebar"
          )
        .job-list-body
          table.row-list.row-job-list
            StartingBusinessListTableHeader(
              :checked="pageAllChecked",
              @check="togglePageCheck"
            )
            StartingBusinessListTableRow(
              v-for="(v, i) in index",
              :startingBusiness="v",
              :index="i",
              :key="v.id",
              :checkedIds="pageCheckedIds",
              :updateFavorForIndex="false",
              @display="displayDetailModal",
              @check="toggleCheck",
              @update="reloadOrUpdate"
            )
        Pagination(
          :pagination="pagination"
          @selectPerPage="selectPerPage"
          @selectPage="selectPage"
        )
      StartingBusinessShowModal(
        :isOpened="openJobShowModal"
        :startingBusinessDetail="jobDetail"
        :updateFavorForIndex="false"
        @update="reloadOrUpdate"
        @hide="hideJobShowModal")
    Footer
</template>

<script>
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
  import { ErrorMessages } from '../constants'
  import StartingBusinessListTableHeader from './parts/StartingBusinessListTableHeader'
  import StartingBusinessListTableRow from './parts/StartingBusinessListTableRow'
  import StartingBusinessShowModal from './parts/StartingBusinessShowModal'
  import StartingBusinessListSidebar from './parts/StartingBusinessListSidebar'
  import StartingBusinessListSortArea from './parts/StartingBusinessListSortArea'
  import Footer from './parts/Footer'
  import Pagination from './parts/Pagination'

  export default {
    components: {
      StartingBusinessListTableHeader,
      StartingBusinessListTableRow,
      StartingBusinessShowModal,
      StartingBusinessListSidebar,
      StartingBusinessListSortArea,
      Pagination,
      Footer,
    },
    async asyncData ({ store, route: { query } }) {
      if (!Object.keys(query).length) {
        throw new Error(ErrorMessages.NO_PARAMETER_SEARCH_STARTING_BUSINESS_LIST)
      }
      await store.dispatch('startingBusinessList/fetchIndex', query)
      await store.dispatch('client/fetch')
    },
    updated () {
      this.avoidBlank()
    },
    created () {
      this.avoidBlank()
    },
    data () {
      return {
        openJobShowModal: false,
        openSidebar: false,
      }
    },
    computed: {
      ...mapGetters('startingBusinessList', ['pageAllChecked']),
      ...mapGetters('common', ['spMode']),
      ...mapGetters('client', ['clientUsers']),
      ...mapState({
        pagination: state => state.startingBusinessList.pagination,
        index: state => state.startingBusinessList.index,
        pageCheckedIds: state => state.startingBusinessList.pageCheckedIds,
        jobDetail: state => state.startingBusiness.detail,
      }),
      page () {
        return this.$route.query.page
      },
      perPage () {
        return this.$route.query.perPage
      },
    },
    methods: {
      ...mapMutations('startingBusinessList', ['check', 'uncheck']),
      ...mapActions('startingBusinessList', ['toggleCheck', 'togglePageCheck']),
      async searchOrderBy (target) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            order: target,
            page: '1',
            _t: Date.now(),
          },
        })
      },
      async selectPerPage (perPage) {
        this.reload({ perPage, page: '1' })
      },
      async selectPage (page) {
        this.reload({ page })
      },
      reload ({ perPage, page } = {}) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            perPage: perPage || query.perPage,
            page: page || query.page,
            _t: Date.now(),
          },
        })
      },
      reloadOrUpdate ({ id }) {
        if (this.spMode) {
          this.$store.dispatch('startingBusinessList/updateIndex', id)
        } else {
          this.reload()
        }
      },
      displayDetailModal ({ id }) {
        if (id !== this.jobDetail.id) {
          this.$store.dispatch('startingBusiness/fetchDetail', { id })
            .then(() => {
              this.openJobShowModal = true
            })
        } else {
          this.openJobShowModal = !this.openJobShowModal
        }
      },
      hideJobShowModal () {
        this.openJobShowModal = false
      },
      avoidBlank () {
        const { query } = this.$route
        const page = parseInt(query.page, 10) || 1

        // 直近の fetchIndex がエラーで終わった場合は page-- しない。
        // 取得失敗で空配列になった画面で page-- を続けるとエラーループになる。
        if (this.$store.state.startingBusinessList.lastFetchError) return

        // 連射防止: API エラー時に暴走して連続リクエストを飛ばすのを防ぐ
        // eslint-disable-next-line no-underscore-dangle
        if (this._avoidBlankGuard) return

        if (!this.index.length && page > 1) {
          // eslint-disable-next-line no-underscore-dangle
          this._avoidBlankGuard = true
          // eslint-disable-next-line no-underscore-dangle
          setTimeout(() => { this._avoidBlankGuard = false }, 3000)
          this.$router.push({ query: { ...query, page: page - 1 } })
        }
      },
      toggleSidebar () {
        this.openSidebar = !this.openSidebar
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/StartingBusinessList.vue